import React from 'react';
import { Circle, Path, Svg } from 'react-native-svg';

interface IconProps {
  size?: number;
  color?: string;
}

export const SolarUserIcon: React.FC<IconProps> = ({ size = 32 , color}) => {
  const COLOR = color || '#7E74E4';
  return(
    <Svg width={size} height={size} viewBox="0 0 32 32" fill="none">

      <Circle
        cx="16"
        cy="12"
        r="4"
        stroke={COLOR}
        strokeWidth="2"
      />
      <Path
        d="M23.9589 26.6667C23.7467 22.8113 22.5663 20 15.9999 20C9.43361 20 8.25321 22.8113 8.04102 26.6667"
        stroke={COLOR}
        strokeWidth="2"
        strokeLinecap="round"
        id='userfirstpart'
      />
      <Path
        d="M9.33268 4.45075C11.2938 3.31629 13.5708 2.66699 15.9993 2.66699C23.3631 2.66699 29.3327 8.63653 29.3327 16.0003C29.3327 23.3641 23.3631 29.3337 15.9993 29.3337C8.63555 29.3337 2.66602 23.3641 2.66602 16.0003C2.66602 13.5717 3.31531 11.2948 4.44978 9.33366"
        stroke={COLOR}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Svg>);

};
